import { Component } from '@angular/core';
import { IconComponent } from './icon.component';

@Component({
  selector: 'app-icon-alert',
  template: `<span class="icon icon-alert" [class.white]="color === 'white'"></span>`,
})
export class AlertIconComponent extends IconComponent { }
